import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import DoorClosed from '@assets/door_closed.svg?react'
import DoorOpen from '@assets/door_open.svg?react'

export default function Doorstatus({ door, status }: { door: number, status: number }) {
  const { t } = useTranslation()
  return <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      visibility: status === -1 ? 'hidden' : 'visible',

    }}
  >
    {status === 1 ?
      <DoorOpen style={{
        borderRadius: "20%",
        width: "70%",
        height: "auto",
        aspectRatio: "1/1"

      }} />
      :
      <DoorClosed style={{
        borderRadius: "20%",
        width: "70%",
        height: "auto",
        aspectRatio: "1/1"
      }} />}
    <Typography fontSize="calc(0.3rem + 0.5vw)" fontWeight="400" mt="-10%">
      {t("faultOverview.door") + " " + door}
    </Typography>

  </Box>

}
